import { css } from 'lit-element';

export const ludsBaseFont = css`
  * {
    font-family: 'Inter', sans-serif;
  }
`;

export const ludsButtonFontStyling = css`
  :host {
    --luds-font-size-14: 14px;
    --luds-font-size-16: 16px;

    --luds-line-height-16: 16px;
    --luds-line-height-18: 18px;
    --luds-line-height-20: 20px;
    --luds-line-height-24: 24px;
  }
`;

export const ludsHeadingXS = css`
  .h-xs {
    color: var(--object-object-primary);
    font-feature-settings: 'cv11' on;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    margin: 0;
  }
`;

export const ludsTypography = css`
  .p-default {
    font-feature-settings: 'cv11' on;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
  }

  .baseline {
    font-feature-settings: 'cv11' on;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const ludsTypographyFontWeight = css`
  .fw-400 {
    font-weight: 400;
  }

  .fw-600 {
    font-weight: 600;
  }
`;
